<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="orderProductsByCaseNumber()"
        @click:row="select"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.caseNumber="{ item }">
          <h3 class="subtitle-2 font-weight-bold">{{ item.caseNumber }}</h3>
          <h4 class="caption grey--text">
            {{ item.products.length }}
            {{ 'contents.table.products' | translate }}
          </h4>
        </template>
        <template v-for="(u, index) in units" v-slot:[`item.${u}`]="{ item }">
          <span
            v-if="scope.name.includes('Thales')"
            :key="(parseFloat(item.shipment)) + index +'Thales'">
            <h4 class="caption">
              {{ u === 'weight' ? item[u].kg : item[u].m }}
              {{ ChangeMessureUnit(u)}}
            </h4>
          </span>
          <span v-if="!scope.name.includes('Thales')" :key="u + index">
            <div v-for="(v, k) in _.get(item.products[0], u)" :key="k">
              {{ (+v).toFixed(2) }} {{ k }}
            </div>
          </span>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="1000">
        <v-card>
          <v-card-text class="pt-4">
            <v-simple-table>
              <thead>
                <tr>
                  <th
                    v-for="f in fieldsByScope" :key="f.text">
                    {{ f.lang ? f.lang : f.text }}:
                  </th>
                </tr>
              </thead>
              <tbody v-if="scope.system !== 'Mpo'">
                <tr v-for="(p, index) in current.products" :key="p.productId + index">
                  <td v-for="f in fieldsByScope" :key="f.value">
                    <span v-if="f.text === 'PO'">{{ _.get(order, 'customerPurchaseOrder') }}</span>
                    <span v-else>{{ p[f.value] }} {{ f.value ==='id' ? p.caseNumber : '' }}</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="scope.name.includes('Thales')">
                <tr v-for="(p, index) in current.products"
                  :key="p.serialNumber + index">
                  <td v-for="f in fieldsByScope" :key="f.value">
                    {{ p[f.value] }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(p, index) in ProductsInMpo(current.products)"
                  :key="p.productId + index">
                  <td v-for="f in fieldsByScope" :key="f.value">
                    {{ p[f.value] }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import { oftype } from '@/utils';
import {
  get,
  set,
  isArray,
} from 'lodash';

export default {
  name: 'app-business-scope-contents',
  data() {
    return {
      dialog: false,
      current: {},
      units: [
        'weight',
        'length',
        'width',
        'height',
      ],
      fields: [
        {
          text: 'Product',
          value: 'id',
          lang: this.$lang.translate('contents.titles.product'),
        },
        // {
        //   text: 'Customer Reference',
        //   value: 'productId',
        // },
        {
          text: 'Product Ref',
          value: 'productId',
          lang: this.$lang.translate('contents.titles.productRef'),
        },
        {
          text: 'Part Number',
          value: 'partNumber',
          lang: this.$lang.translate('contents.titles.customerProductRef'),
        },
        {
          text: 'Serial No.',
          value: 'serialNumber',
          lang: this.$lang.translate('contents.titles.serialNo'),
        },
        {
          text: 'Product Description',
          value: 'description',
          lang: this.$lang.translate('contents.titles.productDescription'),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      result: 'Order',
      scope: 'Scope',
    }),
    order() {
      return this.result;
    },
    contents() {
      const items = get(this.order, 'items');
      if (items) {
        return (oftype(items, 'Array') ? items : [items])
          .map((i) => {
            if (this.isScope('IBM')) {
              set(i, 'id', i.id);
              if (!i.products) set(i, 'products', [i]);
              if (!i.productsInItem) set(i, 'productsInItem', [i]);
            } else {
              set(i, 'products', this.filterProducts(i));
            }

            return i;
          });
      }

      return [];
    },
    headers() {
      return [
        {
          text: this.$lang.translate('contents.table.caseNumber'),
          value: 'caseNumber',
        },
        {
          text: this.$lang.translate('contents.table.weight'),
          sortable: false,
          value: 'weight',
        },
        {
          text: this.$lang.translate('contents.table.length'),
          sortable: false,
          value: 'length',
        },
        {
          text: this.$lang.translate('contents.table.width'),
          sortable: false,
          value: 'width',
        },
        {
          text: this.$lang.translate('contents.table.height'),
          sortable: false,
          value: 'height',
        },
      ];
    },
    fieldsByScope() {
      const fields = this.fields.slice();

      if (this.scope.name === 'KSM') {
        fields.splice(2, 0, {
          text: 'PO no.',
          value: 'customerPurchaseOrderNumber',
        });
      }

      return fields;
    },
  },
  methods: {
    NewThalesHeaders(headers) {
      if (this.scope.name.includes('Thales')) {
        const NewHeaders = headers.filter((i) => {
          if (i.text.includes('Case number') || i.text.includes('Weight')) {
            return true;
          }
          return false;
        });
        NewHeaders.push({ text: 'L x L x H', value: 'LxLxH' });

        return NewHeaders;
      }
      return headers;
    },
    ProductsInMpo(contents) {
      if (this.dialog === true) {
        const productsArray = [];
        productsArray.push(...contents.map(item => item.products));
        const flattenProducts = productsArray.reduce((c, v) => c.concat(v), []);
        return flattenProducts;
      }
      return this.contents.products;
    },
    ChangeToImperial(value, inches) {
      if (inches === true) {
        const valueOnInches = Number(value) / 0.0254;
        return valueOnInches;
      }
      const valueOnPounds = Number(value) * 2.2046;
      return valueOnPounds;
    },
    ChangeMessureUnit(unit, imperial) {
      switch (this.scope.system) {
        case 'Mpo': {
          if (imperial === true) {
            return unit === 'weight' ? 'lb' : 'in';
          }

          if (this.scope.name.includes('Thales')) {
            return unit === 'weight' ? '(KG)' : '(M)';
          }

          return unit === 'weight' ? 'kg' : 'm';
        }
        default: {
          if (imperial === true) {
            return unit === 'weight' ? 'lb' : 'in';
          }

          return unit === 'weight' ? 'kg' : 'cm';
        }
      }
    },
    orderProductsByCaseNumber() {
      const arrayofCaseNumbers = this.contents.map(item => item.caseNumber);
      const cleanCaseNumbers = arrayofCaseNumbers.filter((v, i, a) => a.indexOf(v) === i);
      /* eslint-disable */
      const formatCaseNumbers = cleanCaseNumbers.map(item => {return{
        caseNumber: item,
        products:[]
      }});
      formatCaseNumbers.forEach(i => {
        const FilterValues = this.contents.filter(value => value.caseNumber === i.caseNumber);
        i.products.push(...FilterValues);
      });
      /* eslint-enable */
      if (this.scope.name.includes('Thales')) {
        return isArray(this.order.items)
          ? this.order.items
          : [this.order.items];
      }
      return formatCaseNumbers;
    },
    filterProducts(item) {
      if (!item.productsInItem) return [];

      const products = isArray(item.products)
        ? item.products
        : [item.products];

      return products.filter(p => (
        isArray(item.productsInItem)
          ? item.productsInItem
          : [item.productsInItem]
      ).find(pi => pi.id === p.id));
    },
    isScope(scope) {
      return this.scope.name.toLowerCase() === scope.toLowerCase();
    },
    select(item) {
      if (!item.products) return 0;

      this.current = item;
      this.dialog = true;

      return true;
    },
    quantity(item) {
      if (!item.productsInItem) return 0;

      const quantity = isArray(item.productsInItem)
        ? item.productsInItem
        : [item.productsInItem];
      if (quantity) {
        return (
          oftype(quantity, 'Array') ? quantity : [quantity]
        ).length;
      }
      return 0;
    },
  },
};
</script>
